import React from 'react';

import { Box } from '@mui/material';

interface Props {
  children: React.ReactNode;
  columns?: 1 | 2 | 3 | 4;
}

export default function FieldGrid({ children, columns = 3 }: Props) {
  return (
    <Box
      sx={{
        columnGap: 1.5,
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          md: `repeat(${columns}, minmax(0, 1fr))`,
        },
        rowGap: 6,
      }}
    >
      {children}
    </Box>
  );
}
